import type { ReactNode } from "react";
import { DataTableChromeHost } from "./DataTableChrome";
import { PageHeader } from "./PageHeader";

/**
 * Desk list title row — title left; module tabs · Refresh · ⋯ · primary CTA right.
 * Pair with `DataTableChrome` so the table mounts Reset filters · Refresh · ⋯ into the host.
 */
export function DeskListHeader(props: {
  title: string;
  description?: string;
  eyebrow?: ReactNode;
  /** Module object tabs (`DeskSubNav` with placement="header"). */
  tabs?: ReactNode;
  primaryAction?: ReactNode;
  className?: string;
}) {
  return (
    <PageHeader
      title={props.title}
      description={props.description}
      eyebrow={props.eyebrow}
      className={props.className ?? "items-center"}
      actions={
        <>
          {props.tabs}
          <DataTableChromeHost />
          {props.primaryAction}
        </>
      }
    />
  );
}
